import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a2545] to-[#0d5e63] text-white px-6 py-20">

      <div className="max-w-4xl mx-auto">

        <h1 className="text-4xl font-bold text-teal-300 mb-8">
          Privacy Policy
        </h1>

        <p className="text-gray-200 mb-6 leading-relaxed">
          At YesAuto, we respect your privacy and are committed to protecting
          your personal information. This Privacy Policy explains how we
          collect, use, and protect your information when you use our website
          and submit a financing application.
        </p>

        <h2 className="text-2xl font-semibold text-teal-300 mt-10 mb-3">
          Information We Collect
        </h2>
        <p className="text-gray-200 leading-relaxed">
          When you apply for financing through our website, we may collect
          personal information including your name, phone number, email,
          employment details, income information, and residential address.
        </p>

        <h2 className="text-2xl font-semibold text-teal-300 mt-10 mb-3">
          How We Use Your Information
        </h2>
        <p className="text-gray-200 leading-relaxed">
          The information you provide is used to evaluate your eligibility for
          vehicle financing and to contact you regarding your application.
          Your information may also be shared with lending partners to process
          your request.
        </p>

        <h2 className="text-2xl font-semibold text-teal-300 mt-10 mb-3">
          Cookies & Tracking
        </h2>
        <p className="text-gray-200 leading-relaxed">
          Our website may use technologies such as tracking pixels and
          analytics tools to understand user behavior and improve our services.
          These tools help us measure marketing performance and enhance the
          user experience.
        </p>

        <h2 className="text-2xl font-semibold text-teal-300 mt-10 mb-3">
          Data Protection
        </h2>
        <p className="text-gray-200 leading-relaxed">
          We implement security measures to safeguard your personal information
          from unauthorized access, disclosure, or misuse.
        </p>

        <h2 className="text-2xl font-semibold text-teal-300 mt-10 mb-3">
          Third-Party Services
        </h2>
        <p className="text-gray-200 leading-relaxed">
          Some information may be shared with trusted lenders or financial
          partners strictly for the purpose of evaluating your financing
          request.
        </p>

        <h2 className="text-2xl font-semibold text-teal-300 mt-10 mb-3">
          Contact Us
        </h2>
        <p className="text-gray-200 leading-relaxed">
          If you have questions about this Privacy Policy, please contact us at
          support@yesauto.org.
        </p>

      </div>

    </div>
  );
}